import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Phone, Mail, Facebook, Instagram, Twitter, Globe, Menu, X, ChevronDown, User } from 'lucide-react';
const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [language, setLanguage] = useState('EN');
  const {
    user,
    isAuthenticated
  } = useAuth();
  return <header className="w-full" data-id="element-396">
      {/* Top Bar */}
      <div className="bg-navy-900 text-white py-2 px-4 md:px-8" data-id="element-397">
        <div className="container mx-auto flex flex-wrap justify-between items-center text-sm" data-id="element-398">
          <div className="flex items-center space-x-4" data-id="element-399">
            <div className="flex items-center" data-id="element-400">
              <Phone size={14} className="mr-1" data-id="element-401" />
              <span data-id="element-402">+65 6721 3357</span>
            </div>
            <div className="hidden md:flex items-center" data-id="element-403">
              <Mail size={14} className="mr-1" data-id="element-404" />
              <span data-id="element-405">info@kembarauztaz.com</span>
            </div>
          </div>
          <div className="flex items-center space-x-4" data-id="element-406">
            <div className="flex space-x-2" data-id="element-407">
              <Facebook size={16} className="cursor-pointer hover:text-gold-500" data-id="element-408" />
              <Instagram size={16} className="cursor-pointer hover:text-gold-500" data-id="element-409" />
              <Twitter size={16} className="cursor-pointer hover:text-gold-500" data-id="element-410" />
            </div>
            {/* Auth Links */}
            <div className="hidden md:flex items-center space-x-4" data-id="element-411">
              {isAuthenticated ? <Link to="/dashboard" className="flex items-center text-xs hover:text-gold-500" data-id="element-412">
                  <User size={14} className="mr-1" data-id="element-413" />
                  My Account
                </Link> : <>
                  <Link to="/auth/login" className="text-xs hover:text-gold-500" data-id="element-414">
                    Login
                  </Link>
                  <Link to="/auth/register" className="text-xs hover:text-gold-500 bg-gold-500 text-white px-2 py-1 rounded" data-id="element-415">
                    Sign Up
                  </Link>
                </>}
            </div>
            <button onClick={() => setLanguage(language === 'EN' ? 'MY' : 'EN')} className="flex items-center text-xs hover:text-gold-500" data-id="element-416">
              <Globe size={14} className="mr-1" data-id="element-417" />
              {language}
              <ChevronDown size={14} className="ml-1" data-id="element-418" />
            </button>
          </div>
        </div>
      </div>
      {/* Main Navigation */}
      <div className="bg-white shadow-md" data-id="element-419">
        <div className="container mx-auto flex justify-between items-center py-4 px-4 md:px-8" data-id="element-420">
          <Link to="/" className="flex items-center" data-id="element-421">
            <span className="text-navy-900 font-bold text-2xl" data-id="element-422">
              Kembara Ustaz
            </span>
            <span className="text-gold-500 ml-1" data-id="element-423">✈</span>
          </Link>
          {/* Mobile menu button */}
          <button className="md:hidden text-navy-900" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-424">
            {isMenuOpen ? <X size={24} data-id="element-425" /> : <Menu size={24} data-id="element-426" />}
          </button>
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-6" data-id="element-427">
            <NavLink to="/" data-id="element-428">HOME</NavLink>
            <NavLink to="/about" data-id="element-429">ABOUT KU</NavLink>
            <NavLink to="/umrah" data-id="element-430">UMRAHKU</NavLink>
            <NavLink to="/wisata" data-id="element-431">WISATAKU</NavLink>
            <NavLink to="/shop" data-id="element-432">SHOPKU</NavLink>
            <NavLink to="/private" data-id="element-433">PRIVATE</NavLink>
            <NavLink to="/corporate" data-id="element-434">CORPORATE</NavLink>
            {/* Show this on desktop only if not already shown in top bar */}
            <div className="md:hidden" data-id="element-435">
              {isAuthenticated ? <NavLink to="/dashboard" data-id="element-436">
                  <User size={20} className="mr-1" data-id="element-437" />
                  ACCOUNT
                </NavLink> : <NavLink to="/auth/login" data-id="element-438">LOGIN</NavLink>}
            </div>
          </nav>
        </div>
        {/* Mobile Navigation */}
        {isMenuOpen && <nav className="md:hidden bg-white border-t py-4 px-6" data-id="element-439">
            <div className="flex flex-col space-y-4" data-id="element-440">
              <MobileNavLink to="/" onClick={() => setIsMenuOpen(false)} data-id="element-441">
                HOME
              </MobileNavLink>
              <MobileNavLink to="/about" onClick={() => setIsMenuOpen(false)} data-id="element-442">
                ABOUT KU
              </MobileNavLink>
              <MobileNavLink to="/umrah" onClick={() => setIsMenuOpen(false)} data-id="element-443">
                UMRAHKU
              </MobileNavLink>
              <MobileNavLink to="/wisata" onClick={() => setIsMenuOpen(false)} data-id="element-444">
                WISATAKU
              </MobileNavLink>
              <MobileNavLink to="/shop" onClick={() => setIsMenuOpen(false)} data-id="element-445">
                SHOPKU
              </MobileNavLink>
              <MobileNavLink to="/private" onClick={() => setIsMenuOpen(false)} data-id="element-446">
                PRIVATE
              </MobileNavLink>
              <MobileNavLink to="/corporate" onClick={() => setIsMenuOpen(false)} data-id="element-447">
                CORPORATE
              </MobileNavLink>
              {/* Auth links for mobile */}
              <div className="pt-4 mt-2 border-t border-gray-200" data-id="element-448">
                {isAuthenticated ? <MobileNavLink to="/dashboard" onClick={() => setIsMenuOpen(false)} data-id="element-449">
                    <div className="flex items-center" data-id="element-450">
                      <User size={20} className="mr-2" data-id="element-451" />
                      MY ACCOUNT
                    </div>
                  </MobileNavLink> : <>
                    <MobileNavLink to="/auth/login" onClick={() => setIsMenuOpen(false)} data-id="element-452">
                      LOGIN
                    </MobileNavLink>
                    <MobileNavLink to="/auth/register" onClick={() => setIsMenuOpen(false)} data-id="element-453">
                      SIGN UP
                    </MobileNavLink>
                  </>}
              </div>
            </div>
          </nav>}
      </div>
    </header>;
};
const NavLink = ({
  to,
  children
}) => <Link to={to} className="text-navy-900 font-medium hover:text-gold-500 transition-colors" data-id="element-454">
    {children}
  </Link>;
const MobileNavLink = ({
  to,
  children,
  onClick
}) => <Link to={to} className="text-navy-900 font-medium hover:text-gold-500 transition-colors block py-2" onClick={onClick} data-id="element-455">
    {children}
  </Link>;
export default Header;